import React from 'react';
import cn from 'classnames';
import { useStoreState } from 'base/store';
import AfterPaySteps from '@base/common/payMent/AfterPay/AfterPaySteps';
import styles from './index.module.less';
import Image from '@base/lib/ThemeImage';
import { Trans } from 'base/utils/i18n';

type IProps = {
    showTitle?: boolean;
}

const msgs = {
    US: {
        text: 'web_product_afterpay_help_us',
        link: 'https://www.afterpay.com/en-US/installment-agreement'
    },
    CA: {
        text: 'web_product_afterpay_help_ca',
        link: 'https://www.afterpay.com/en-CA/instalment-agreement'
    },
    AU: {
        text: 'web_product_afterpay_help_au',
        link: 'https://www.afterpay.com/en-AU/terms-of-service'
    },
}

const AfterPayInfo: React.FC<IProps> = (props) => {
    const {
        showTitle = true
    } = props

    const { ua: { isPhone }, country } = useStoreState('rootStore');

    const _i18nKeys = msgs[country];

    return (
        <div className={cn('text-center', styles['after-pay-info'])}>

            {showTitle && (
                <div className={styles['title-img']}>
                    <Image
                        src={'asset/width-291/picture/ade82c9b5075c6baef6de841b2e39e3f.png'}
                        width={97}
                        height={18}
                        fixed
                        background={false}
                    />
                </div>
            )}

            <div className={styles['sub-title']}>
                <Trans
                    i18nKey={'web_product_afterpay_title'}
                    components={{ br: isPhone ? <br/> : <></> }}
                />
            </div>

            <AfterPaySteps/>

            {_i18nKeys && (
                <div className={styles.msg}>
                    <Trans
                        i18nKey={_i18nKeys.text}
                        components={{
                            a: <a href={_i18nKeys.link} target={"_blank"} rel="noopener noreferrer"/>
                        }}
                    />
                </div>
            )}
        </div>
    );
};

export default AfterPayInfo